import React, { PropsWithChildren } from "react"
import { Box } from "@chakra-ui/layout"
import {
    AccordionButton,
    AccordionItem,
    AccordionIcon,
    AccordionPanel,
} from "@chakra-ui/accordion"
import Subheading from "../../../shared/text/subheading"

interface Props {
    question: string
}

export default function QuestionItem({
    question,
    children,
}: PropsWithChildren<Props>) {
    return (
        <AccordionItem borderColor="gray.300">
            <Subheading as="h2">
                <AccordionButton py={6}>
                    <Box
                        as="span"
                        flex="1"
                        textAlign="left"
                        fontSize={{ base: "sm", xl: "xl" }}
                        fontWeight="extrabold"
                    >
                        {question}
                    </Box>
                    <AccordionIcon />
                </AccordionButton>
            </Subheading>
            <AccordionPanel
                px={8}
                pb={6}
                fontSize={{ base: "sm", md: "md" }}
                fontWeight="normal"
                color="navy.700"
            >
                {children}
            </AccordionPanel>
        </AccordionItem>
    )
}
